import { Component, OnInit } from '@angular/core';
import { PopoverController, ModalController } from '@ionic/angular';
//import { ScheduleEventComponent } from '@app/shared/calendarEvent/schedule-event/schedule-event.component';

@Component({
  selector: 'app-call-opts',
  templateUrl: './call-opts.component.html',
  styleUrls: ['./call-opts.component.scss']
})
export class CallOptsComponent implements OnInit {
  idUser: any;
  phone: string;
  type: string;

  constructor(private popoverController: PopoverController, private modalCtrl: ModalController) {}

  ngOnInit() {}

  async close() {
    await this.popoverController.dismiss();
  }

  async add(type: number) {
    type;
    // await this.close();
    // const modal = await this.modalCtrl.create({
    //   component: ScheduleEventComponent,
    //   componentProps: {
    //     userId: this.idUser,
    //     typeEvent: type
    //   }
    // });
    // return await modal.present();
  }
}
